<script setup lang="ts">
import type { IconData } from '@/types/icon.model'
import CustomIcon from './CustomIcon.vue'
defineProps({
  color: {
    type: String,
    default: '#ffffff'
  }
})
const iconData: IconData = {
  path: 'M13 0C13.6562 0 14.2656 0.375 14.5938 0.9375L24.7188 18.1875C25.0469 18.7969 25.0469 19.5 24.7188 20.0625C24.3906 20.6719 23.7812 21 23.125 21H2.875C2.17188 21 1.5625 20.6719 1.23438 20.0625C0.90625 19.5 0.90625 18.7969 1.23438 18.1875L11.3594 0.9375C11.6875 0.375 12.2969 0 13 0ZM13 6C12.3438 6 11.875 6.51562 11.875 7.125V12.375C11.875 13.0312 12.3438 13.5 13 13.5C13.6094 13.5 14.125 13.0312 14.125 12.375V7.125C14.125 6.51562 13.6094 6 13 6ZM14.5 16.5C14.5 15.7031 13.7969 15 13 15C12.1562 15 11.5 15.7031 11.5 16.5C11.5 17.3438 12.1562 18 13 18C13.7969 18 14.5 17.3438 14.5 16.5Z',
  fill: ''
}
</script>
<template>
  <CustomIcon :size="24" viewBox="0 0 26 21" :color="color" :d="[iconData]" />
</template>
